export default "__VITE_ASSET__Bex5Lswf__"